export const Roles = {
    DualloAdmin: "duallo-admin",
    OrganizationAdmin: "organization-admin",
    AssetAdmin: "asset-admin",
    Inspector: "inspector",
    User: "viewer"
}

export const ProtectedRoles = [
    Roles.DualloAdmin,
    Roles.OrganizationAdmin
]